module.exports = __webpack_public_path__ + "img/csm_panta_rhei_d3702a6a26.205965a3.jpg";